import {
    FINTECH_SYNCLOG_LOAD_SUCCESS,
    FINTECH_SYNCLOG_ERROR,
    FINTECH_SYNCLOG_LOADING,
} from "./constants";
import { generateReducer } from "../common/helpers";

const initialState = {
    errors: {}, // Errors indexed by invoiceId
    isLoading: {}, // Loading states indexed by invoiceId
    syncLogs: {}, // SyncLogs indexed by invoiceId
};

const setSyncLogs = (state, { data }) => {
    let newState = { ...state, isLoading: {}, errors: {} }; // Resetting loading and error states for all invoiceIds involved

    const ids = new Set();
    data.forEach(log => {
        log.invoice_ids.forEach(invoiceId => {
            if (!newState.syncLogs[invoiceId]) {
                newState.syncLogs[invoiceId] = [];
            }
            ids.add(invoiceId);
            newState.syncLogs[invoiceId].push(log); // Push the log to the array for each affected invoiceId
        });
    });
    Array.from(ids).forEach(invoiceId => {
        newState.isLoading[invoiceId] = false; // Set loading to false for each affected invoiceId
        newState.errors[invoiceId] = null; // Optionally clear errors for each affected invoiceId
    });

    return newState;
};

const setSyncError = (state, { invoiceIds, error }) => {
    let newState = { ...state };

    invoiceIds.forEach(invoiceId => {
        newState.isLoading[invoiceId] = false; // Set loading to false for each affected invoiceId
        newState.errors[invoiceId] = error; // Set the error for each affected invoiceId
    });

    return newState;
};

const setSyncLoading = (state, { invoiceIds }) => {
    let newState = { ...state };

    invoiceIds.forEach(invoiceId => {
        newState.isLoading[invoiceId] = true; // Set loading to true for each affected invoiceId
        newState.errors[invoiceId] = null; // Optionally clear errors for each affected invoiceId
    });

    return newState;
};

const reducers = {
    [FINTECH_SYNCLOG_LOAD_SUCCESS]: setSyncLogs,
    [FINTECH_SYNCLOG_ERROR]: setSyncError,
    [FINTECH_SYNCLOG_LOADING]: setSyncLoading,
};

export default generateReducer(reducers, initialState);
